<template>
  <div>
    <div class="launch-content" v-show="isShowList">
      <Ad activeType="landingPage">
        <span slot="landingPage">
          <List @create="handleCreate" @edit="handleEdit" ref="list"></List>
        </span>
      </Ad>
    </div>
    <div v-if="!isShowList && mode !=='read'">
      <Add :mode="mode" :landingPageId="landingPageId" @go-back="handleGoBack"></Add>
    </div>
  </div>
</template>
<script>
import Ad from '@/components/Ad'
import List from './LandingPageList'
import Add from './LandingPageAdd'
export default {
  components: {
    Ad,
    List,
    Add
  },
  data() {
    return {
      isShowList: true,
      landingPageId: undefined,
      mode: 'create'
    }
  },
  methods: {
    handleCreate() {
      this.isShowList = false
      this.mode = 'create'
      this.landingPageId = undefined
    },
    handleEdit(item) {
      this.landingPageId = item.landingPageId
      this.mode = 'edit'
      this.isShowList = false
    },
    handleGoBack(item) {
      this.isShowList = true
      this.mode = 'list'
      this.$nextTick(() => {
        this.$refs.list.fetchData()
      })
    }
  },
  created() {
  },
  activated() {
    if (this.$route.params.add) {
      this.handleCreate()
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>
